const BRAND_INFO_LOCAL_STORAGE_KEY = "brand-info";
const CONCIERGE_DATA_STORAGE_KEY = "pip-data";
const isPaired = !!window.localStorage.getItem(CONCIERGE_DATA_STORAGE_KEY) && !window.location.pathname.includes("/pair");

function showContent() {
  const allowed_routes = ["/login", "/"];
  return window.location.pathname && allowed_routes.includes(window.location.pathname);
}

async function generateLogoPlaceholder(brand) {
  const logo_placeholder = document.getElementById("logo-placeholder");
  if (!logo_placeholder) return;
  const image = document.createElement("img");
  image.src = brand.logo_url;
  image.alt = brand.display_name;
  image.title = brand.display_name;
  image.classList.add("w-[16rem]");
  logo_placeholder.appendChild(image);

  // Check when image loaded
  return new Promise((resolve) => {
    image.addEventListener("load", () => {
      resolve();
    });

    image.addEventListener("error", () => {
      logo_placeholder.removeChild(image);
      localStorage.removeItem(BRAND_INFO_LOCAL_STORAGE_KEY);

      resolve();
    });
  });
}

async function generatePlaceholderContent(brand) {
  await generateLogoPlaceholder(brand);
}

// HACK: This is a temporary solution to get the brand data from the S3 bucket for new patient app domain
function getBrandsJsonFilename(host) {
  if (isPaired) {
    const conciergeData = window.localStorage.getItem(CONCIERGE_DATA_STORAGE_KEY);
    const siteUrl = conciergeData ? JSON.parse(conciergeData).siteUrl : "";
    if (!siteUrl) return "";
    const hostName = siteUrl.split("/")[2];
    return `${hostName}.json`;
  }

  return `${host}.json`;
}

function setBrandInfo(brandInfo) {
  window.localStorage.setItem(
    BRAND_INFO_LOCAL_STORAGE_KEY,
    JSON.stringify({
      ttl: Date.now() + 3600000, // 1 hour
      value: brandInfo,
    })
  ); // This should match the BRAND_INFO_LOCAL_STORAGE_KEY key
}

function getCachedBrandInfo() {
  const brandDataJson = window.localStorage.getItem(BRAND_INFO_LOCAL_STORAGE_KEY);

  if (!brandDataJson) {
    return null;
  }

  const brandData = JSON.parse(brandDataJson);

  if (brandData.ttl && brandData.ttl < Date.now()) {
    return null;
  }

  return brandData.value || null;
}

/**
 * Attempt to fetch the cached brand from S3 via Cloudfront
 */
async function fetchBrandData() {
  const { protocol, host } = window.location;
  let parsedBrandInfo = getCachedBrandInfo();

  if (!parsedBrandInfo) {
    try {
      const filename = getBrandsJsonFilename(host);
      if (!filename) return;

      const brandResponse = await fetch(`${protocol}//${host}/brands/${filename}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (brandResponse.status !== 200) throw new Error(`Error fetching brand data: ${brandResponse.status}`);
      parsedBrandInfo = await brandResponse.json();
    } catch (error) {
      console.info("Error fetching brand data - falling back to full domains call", error);
      return;
    }
  }

  setBrandInfo(parsedBrandInfo);

  if (parsedBrandInfo.logo_url && showContent()) {
    await generatePlaceholderContent(parsedBrandInfo);
  }
}

/* Go to the root of the app if the user hits an error page. This will handle cases where the user has been redirected from old domains to the new domain
and the user hits an error page. As this code will be initialised before any Angular application code and any navigations to the error routes are handled by the Navigation service,
we can safely assume that this code will be hit only on refreshes or redirects as mentioned above. */
if (window.location.pathname === "/error") {
  window.location.pathname = "/";
}

// eslint-disable-next-line @typescript-eslint/no-floating-promises
fetchBrandData();
